module.exports = __webpack_public_path__ + "static/media/concept-energy-label-c.e10bb852.svg";